// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"796d0815","977":"05a7a361"}[chunkId] + ".chunk.js";
};